import { Goal } from './Goal';

export const kind = 'Rebuild';

export type Rebuild = Goal<typeof kind>;
